import React, {Component} from 'react'
import {connect} from 'react-redux'
import {push} from 'connected-react-router'
import {actionCreators} from 'actions'
import api from 'api'
import {find, get, identity, indexOf, isEmpty} from 'lodash'
import {formMap} from 'procedureStatuses/ReportEdit'
import {Redirect, withRouter} from 'react-router'
import {asyncError} from 'store/actions/asyncError'

const needDetailInputProcedures = ['enroll', 'resign']

class Flow extends Component {
  static defaultProps = {
    flowStatus: {},
  }

  componentDidMount() {
    const {
      match: {
        params: {id},
      },
      token,
      loadProcedure,
      loadTmpData,
      embed,
      params,
    } = this.props
    loadProcedure(id, token, embed, params)
    loadTmpData(id, token)
  }

  componentWillUnmount() {
    this.props.destroy()
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loading && this.props.loading) {
      const {
        procedureStatus,
        setStatus,
        match: {
          params: {id},
        },
        flowStatus,
      } = nextProps
      if (procedureStatus.status !== 'draft') {
        nextProps.history.replace(`/procedure_statuses/${id}`)
        return
      }
      if (needDetailInputProcedures.includes(procedureStatus.procedure_type) && !flowStatus.detailFinished) {
        nextProps.history.replace(`/${procedureStatus.procedure_type}/detail/${id}`)
        return
      } else {
        const status = flowStatus.status || {}
        const {
          employee,
          makeFlow,
          startProgress,
          token,
          match: {params},
        } = nextProps
        const flow = [...makeFlow(employee, procedureStatus, flowStatus)]
        if (flow.every((report) => status[report])) {
          startProgress(token, params.id)
        } else {
          setStatus(status)
        }
      }
    }
  }

  afterSubmit = async () => {
    const {
      current,
      finishStep,
      status,
      token,
      startProgress,
      match: {params},
      saveStatus,
      makeFlow,
      employee,
      procedureStatus,
      flowStatus,
    } = this.props
    const flow = [...makeFlow(employee, procedureStatus, flowStatus)]
    finishStep(current)
    const currentIndex = indexOf(flow, current)
    const nextIndex = flow.findIndex((value, index) => index > currentIndex && !status[value])
    if (nextIndex < 0) {
      startProgress(token, params.id)
    } else {
      await saveStatus(token, params.id, status, current)
      this.props.history.push({pathname: this.props.location.pathname, hash: `#${flow[nextIndex]}`})
      window.scrollTo(0, 0)
    }
  }

  render() {
    const {
      current,
      match: {
        params: {id},
      },
      makeFlow,
      employee,
      status,
      procedureStatus,
      flowStatus,
    } = this.props
    if (!status) {
      return null
    }
    const flow = [...makeFlow(employee, procedureStatus, flowStatus)]
    if (!flow.includes(current)) {
      const notFinished = find(flow, (value) => !status[value])
      return notFinished ? <Redirect to={{pathname: this.props.location.pathname, hash: `#${notFinished}`}} /> : null
    }
    const currentIndex = indexOf(flow, current)
    const nextIndex = flow.findIndex((value, index) => index > currentIndex && !status[value])
    const [report, dependentId] = current ? current.split('_') : []
    const Form = report ? formMap[report] : null
    return (
      <div>
        {current && Form && (
          <Form
            key={dependentId}
            submitText={nextIndex >= 0 ? '次へ' : '完了'}
            procedureStatusId={id}
            afterSubmit={this.afterSubmit}
            dependentId={dependentId}
          />
        )}
      </div>
    )
  }
}

export default withRouter(
  connect(
    (state, ownProps) => {
      const current = ownProps.location.hash ? ownProps.location.hash.slice(1) : ''
      const employee = get(state, 'procedureStatuses.current.data.employee')
      return {
        token: state.auth.token,
        procedureStatus: state.procedureStatuses.current.data,
        flowStatus: state.procedureStatuses.tmpData.data.draft_flow_status,
        loading:
          state.procedureStatuses.tmpData.loading ||
          state.procedureStatuses.current.loading ||
          isEmpty(employee) ||
          isEmpty(employee.office),
        employee,
        status: state.procedures.status,
        current,
      }
    },
    (dispatch) => ({
      finishStep: (current) => dispatch(actionCreators.procedures.finishStep(current)),
      loadProcedure: (id, token, embed, params) => {
        dispatch(
          actionCreators.procedureStatuses.current.fetchData(
            api
              .createWithAuth(token)
              .procedureStatuses.get(
                id,
                [
                  'employee',
                  'employee_dependents',
                  'health_insurance',
                  'welfare_pension_insurance',
                  'employment_insurance',
                  'my_number_present',
                  'office',
                  embed,
                ].filter(identity),
                params
              )
          )
        )
      },
      loadTmpData(id, token) {
        dispatch(
          actionCreators.procedureStatuses.tmpData.fetchData(
            api.createWithAuth(token).procedureStatuses.tmpData.mapToJson(id, 'draft', 'flow_status')
          )
        )
      },
      destroy() {
        dispatch(actionCreators.procedureStatuses.current.destroy())
        dispatch(actionCreators.procedureStatuses.tmpData.destroy())
        dispatch(actionCreators.procedures.setStatus(null))
      },
      setStatus: (status) => {
        dispatch(actionCreators.procedures.setStatus(status))
      },
      startProgress: async (token, procedureStatusId) => {
        try {
          await api.createWithAuth(token).procedureStatuses.startProgress(procedureStatusId)
          dispatch(push(`/procedure_statuses/${procedureStatusId}`))
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
      saveStatus: async (token, procedureStatusId, status, current) => {
        try {
          await api.createWithAuth(token).procedureStatuses.tmpData.updateJson(
            procedureStatusId,
            'draft',
            'flow_status',
            (
              data = {
                detailFinished: true,
                status: {},
              }
            ) => ({
              ...data,
              status: {
                ...data.status,
                [current]: true,
              },
            })
          )
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
    })
  )(Flow)
)
